import { makeStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';
import ErrorIcon from '@material-ui/icons/Error';
import WarningIcon from '@material-ui/icons/Warning';
import { decimal, qualitySampleResults } from '../../../Config/constants';

export default function SamplingResultsNotOKContent(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    let totalResultIcon = <ErrorIcon className={classes.error}></ErrorIcon>
    let subTitle = t("The QA division has been notified.")
    let title = t("Results not OK!")
    if (!props.qualityChecksNotOK.some(x => x.result === qualitySampleResults.ERROR)) {
        totalResultIcon = <WarningIcon className={classes.warning}></WarningIcon>
        title = "Let op!"
        subTitle = "Actie ondernemen om bij te regelen."
    }

    return (
        <div className={classes.container}>
            <div className={classes.headerIcon}>
                {totalResultIcon}
            </div>
            <div className={classes.title}>{title}</div>
            <div className={classes.subTitle}>{subTitle}</div>
            <div className={classes.body}>
                <div className={classes.qualityCheckContainer}>
                    {props.qualityChecksNotOK.map((x, qcindex) => {

                        let expected = ""
                        let measured = ""
                        if (x.dataTypeId === decimal && x.question === '') {
                            let uom = ""
                            if (x.description.includes('Length')) {
                                uom = "mm"
                                expected = Array(5).fill('\xa0').join('') + t("Expected: ") + x.expectedValue + uom
                            }
                            if (x.description.includes('Width')) {
                                uom = "mm"

                                expected = Array(5).fill('\xa0').join('') + t("Expected: ") + x.expectedValue + uom
                            }
                            if (x.description.includes('Weight')) {
                                uom = "g"

                                expected = Array(5).fill('\xa0').join('') + t("Expected: ") + x.expectedValue + uom
                            }
                            if (x.description.includes('Thickness')) {
                                uom = "mm"

                                expected = Array(5).fill('\xa0').join('') + t("Expected: ") + x.expectedValue + uom
                            }
                            measured = t("Measured: ") + x.sampleValue + uom
                        }
                        let warning = x.result === qualitySampleResults.WARNING
                        let resultIcon = <ClearRoundedIcon className={classes.clearIcon} style={{ float: measured !== "" && "left", marginLeft: measured !== "" && "10px" }}></ClearRoundedIcon>
                        if (warning) {
                            resultIcon = <ErrorIcon className={classes.warningIcon} style={{ float: measured !== "" && "left", marginLeft: measured !== "" && "10px" }}></ErrorIcon>
                        }

                        return (<div className={classes.qualityCheckNotOK} key={"65_qcindex_" + qcindex} style={{ backgroundColor: warning ? "rgb(255,165,0,0.3)" : "#FFD8D8", border: warning ? "1px solid rgb(255,165,0)" : "1px solid #D84949" }}>
                            <div className={classes.name} style={{ borderBottom: warning ? "1px solid rgb(255,165,0)" : "1px solid #D84949" }}>{x.description + expected}</div>
                            <div className={classes.icon}>
                                {resultIcon}
                                <div className={classes.measured}>{measured}</div>
                            </div>
                        </div>)
                    })}
                </div>
            </div>
            <div className={classes.finishTest}>
                <button className={classes.finishButton} onClick={() => props.finishTest()}>{t("FINISH TEST")}</button>
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    container: {
        width: "calc(100% - 150px)",
        float: "left",
        padding: "40px",
        boxSizing: "border-box",
        height: "80vh",
        position: "relative",
        top: "90px",
        left: "150px"
    },
    headerIcon: {
        width: "100%",
        textAlign: "center",
        marginTop: "50px",
    },
    error: {
        width: "80px",
        height: "80px",
        marginBottom: "10px",
        color: "#D84949"
    },
    warningIcon: {
        color: "#FFA500",
        marginTop: "4px",
        width: "30px",
        height: '30px',
        marginLeft: "20px"
    },
    warning: {
        width: "80px",
        height: "80px",
        marginBottom: "10px",
        color: "#FFA500"
    },
    smallDone: {
        width: "20px",
        height: "20px",
        marginTop: "8px"
    },
    title: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        color: "#020100",
        textAlign: "center"
    },
    subTitle: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        color: "#020100",
        textAlign: "center"
    },
    qualityCheckNotOK: {
        width: "auto",
        minWidth: "120px",
        height: "80px",
        borderRadius: "5px",
        margin: "5px",
        marginTop: "30px",
        float: "left",
    },
    name: {
        width: "100%",
        height: "40px",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold",
        color: "#020100",
        textAlign: "center",
        boxSizing: "border-box",
        paddingTop: "10px",
        paddingLeft: "10px",
        paddingRight: "10px"
    },
    icon: {
        textAlign: "center",
        backgroundColor: "white",
        width: "100%",
        height: "40px",
        borderRadius: "0 0 5px 5px",
        paddingLeft: "10px",
        paddingRight: "10px",
        boxSizing: "border-box"
    },
    finishButton: {
        width: "120px",
        height: "40px",
        borderRadius: "5px",
        marginTop: "50px",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: "white",
        fontWeight: "bold",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        border: "none",
        outline: "none",
        cursor: "pointer"
    },
    finishTest: {
        width: "100%",
        textAlign: "center"
    },
    body: {
        width: "100%",
        textAlign: "center"
    },
    clearIcon: {
        color: "#D84949",
        marginTop: "4px",
        width: "30px",
        height: '30px',
        marginLeft: "20px"
    },
    qualityCheckContainer: {
        width: "fit-content",
        maxWidth: "900px",
        marginRight: "auto",
        marginLeft: "auto",
        marginTop: "20px",
        overflow: "auto"
    },
    measured: {
        float: "right",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold",
        color: "#020100",
        marginTop: "10px",
        marginRight: "20px"
    }
});